import { useEffect, useState } from 'react';
import { Card, CardBody } from '../../../../components/card/card';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { GetFleetCategory } from '../../../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Loading from '../../../../components/Shared/Loader/Loading';
import useLookupFleetInspectionType from '@hooks/Lookups/use-Lookup-FleetInspectionType';

const Index = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const [search, setSearch] = useState('');
  const Navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { FleetInspectionTypeOptions } = useLookupFleetInspectionType();
  const { FleetCategory, loading } = useAppSelector(state => state.Lookup);

  useEffect(() => {
    dispatch(GetFleetCategory());
  }, []);

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
           link: ':moduleHome'
          },
          {
            name: t('InspectionItems'),
            link: null
          }
        ]}
        PageName={t('InspectionItems')}
      />

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <div className='row'>
              <div className='col-xl-3  '>
                <div className='input-group flex-nowrap mb-2'>
                  <span className='input-group-text'>{t('Search')}</span>
                  <input
                    type='text'
                    autoComplete='off'
                    className='form-control '
                    onChange={e => {
                      setSearch(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* //  START TABLE   */}
            <div className='table-responsive'>
              <table className='table table-hover '>
                <thead className='bg-theme bg-opacity-30'>
                  <tr>
                    <th>{t('Name')}</th>
                    <th className='text-end'></th>
                  </tr>
                </thead>
                <tbody>
                  {FleetCategory &&
                    FleetCategory?.map((item: any, idx) =>
                      item.list?.map((list: any) => (
                        <tr key={list.lookupCode}>
                          <td className='align-middle'>{i18n.language === 'ar' ? list.meaning2 : list.meaning}</td>
                          <td className='align-middle text-end'>
                            <div className='btn-group'>
                              <div className='btn-group' role='group' dir={isRTL ? 'rtl' : 'ltr'}>
                                <button
                                  type='button'
                                  className='btn btn-theme dropdown-toggle'
                                  data-bs-toggle='dropdown'
                                  aria-expanded='false'
                                  aria-label={t('NewMaintenanceOrder')}
                                  title={t('NewMaintenanceOrderTooltip')}
                                >
                                  {t('InspectionTypes')}
                                </button>

                                <ul
                                  className={`dropdown-menu ${isRTL ? 'dropdown-menu-end' : 'dropdown-menu-start'}`}
                                  style={{ textAlign: isRTL ? 'right' : 'left' }}
                                >
                                  {FleetInspectionTypeOptions?.map((type: any, index: any) => (
                                    <li key={type.value}>
                                      <Link
                                        className='dropdown-item d-flex align-items-center'
                                        to={`${list.lookupCode}/${type.value}/AddScanElement`}
                                      >
                                        <i
                                          className={`bi bi-lightning fa-lg ${isRTL ? 'me-2' : 'ms-2'} text-theme`}
                                          aria-hidden='true'
                                        />
                                        {type.label}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>

                              <button
                                type='button'
                                onClick={() => Navigate(`${list.lookupCode}/AddScanElement`)}
                                className='btn btn-sm btn-theme ms-2 '
                                data-toggle='tooltip'
                                title={t('InspectionItems')}
                              >
                                <i className='fa-lg fa-fw bi bi-list-ul me-2'></i>
                                {/* {t('InspectionItems')} */}
                                {t('InspectionItemsReceiveAndDelivery')}
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Loading>
      </Card>
      <style>{`
      .dropdown-toggle::after {
      margin-right: 10px;
      }
      `}</style>
    </>
  );
};

export default Index;
